import type { Variations } from 'types/builder/interface';

import { EditorLocationEnum, FieldTypesEnum } from 'constants/builder/enums';
import { v4 } from 'uuid';

import type { GetVariationTitleProps, GetSelectedValueProps } from './types';

export const getVariationTitle = ({
    isAddingClauseVariations,
    isAddingBlockVariations,
    variationsBlock,
    variationsField
}: GetVariationTitleProps) => {
    if (isAddingClauseVariations || isAddingBlockVariations) {
        if (variationsBlock) {
            return variationsBlock[0][0].title;
        }

        if (variationsField) {
            return variationsField[0][0].title;
        }
    }

    return '';
};

export const getSelectedValue = ({
    variationsBlock,
    variationsField,
    selectedField,
    location
}: GetSelectedValueProps) => {
    if (location === EditorLocationEnum.Field) {
        return selectedField?.type || FieldTypesEnum.Text;
    }

    if (variationsBlock) {
        return variationsBlock[0][0].type;
    }

    if (variationsField) {
        return variationsField[0][0].type;
    }

    if (location === EditorLocationEnum.Block || location === EditorLocationEnum.Clause) {
        return FieldTypesEnum.Radio;
    }

    return FieldTypesEnum.Text;
};

export const getVariationItems = (variationsBlock?: Variations, variationsField?: Variations) => {
    if (variationsBlock) {
        return variationsBlock[0][0].value.map(item => ({
            ...item,
            id: v4()
        }));
    }

    if (variationsField) {
        return variationsField[0][0].value.map(item => ({
            ...item,
            id: v4()
        }));
    }

    return [
        {
            value: {
                value: '',
                type: ''
            },
            isDefault: true,
            text: '',
            id: v4()
        },
        {
            value: {
                value: '',
                type: ''
            },
            isDefault: true,
            text: '',
            id: v4()
        }
    ];
};

export const reorder = (list: any[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
